var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassTagInteractive", {
    staticClass: "listing-table-actions__filters-tag",
    attrs: {
      modelValue: _vm.type,
      color: "blue",
      keyLabel: _vm.label + " : ",
      valueLabel: _vm.valuesHumanized
    },
    on: { "tag-remove": _vm.handleRemoveFilter },
    nativeOn: {
      click: function($event) {
        return _vm.handleClickOnTag($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }